// extracted by mini-css-extract-plugin
export default {"host-detail__container":"styles_host-detail__container__SgKMS"};